module.exports = __webpack_public_path__ + "static/img/kangkeer.8b140f57.png";